import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.33 13.7c0 .313.108.577.324.793.216.216.486.33.81.341h9.072c.312 0 .582-.114.81-.341.228-.229.336-.492.324-.793V4.61c0-.312-.108-.582-.324-.81a1.014 1.014 0 0 0-.81-.324H4.464c-.312 0-.582.108-.81.324a1.014 1.014 0 0 0-.324.81v9.09Z",
  fill: "#F59600"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };